import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/auth.service';
import { ChangePasswordService } from 'src/app/change-password.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  currentPassword = '';
  newPassword = '';
  confirmNewPassword = '';
  userId = 0;
  isLoading = false;
  message = '';
  isSuccess = false;
  showPassword: boolean = false; // Password visibility toggle
  // Define the minimum password length
  private readonly MIN_PASSWORD_LENGTH = 8;


  // Validate if new password and confirm new password match
  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmNewPassword;
  }

  // Validate if the new password meets the minimum length
  get isPasswordValid(): boolean {
    return this.newPassword.length >= this.MIN_PASSWORD_LENGTH;
  }

  constructor(
    private changePasswordService: ChangePasswordService,
    private authService: AuthService,
    private snackBar: MatSnackBar // Inject MatSnackBar service
  ) {}

  ngOnInit(): void {
    const user = this.authService.getUserDetails();
    if (user && user.userId) {
      this.userId = Number(user.userId); // Convert string to number
    }
  }

  async onSubmit(passwordForm: NgForm) {
    // Check if passwords match
    if (!this.passwordsMatch) {
      this.message = 'New Password and Confirm New Password do not match!';
      this.isSuccess = false;
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
      return;
    }
  
    // Check if password meets minimum length
    if (!this.isPasswordValid) {
      this.message = `Password must be at least ${this.MIN_PASSWORD_LENGTH} characters long.`;
      this.isSuccess = false;
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
      return;
    }
  
    // Check if new password is the same as the old password
    if (this.currentPassword === this.newPassword) {
      this.message = 'New password cannot be the same as the current password!';
      this.isSuccess = false;
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
      return;
    }
  
    // Show loading indicator
    this.isLoading = true;
    this.message = '';
  
    try {
      // Call the change password service asynchronously
      const response = await this.changePasswordService.changePassword(
        this.userId,
        this.currentPassword,
        this.newPassword
      );
  
      // Handle success
      this.isSuccess = true;
      this.message = response.message || 'Password changed successfully!';
      this.showSnackBar(this.message, 'success'); // Show snackbar on success
  
      // Clear the fields after successful change
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
  
      // Mark form controls as untouched after clearing the fields
      passwordForm.resetForm();
    } catch (error) {
      // Handle error
      this.isSuccess = false;
      this.message =
        error.error?.message || 'An error occurred while changing the password.';
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
    } finally {
      // Hide loading indicator
      this.isLoading = false;
    }
  }
  

  // // Method to display the snackbar message
  // private showSnackBar(message: string, type: 'success' | 'error'): void {
  //   const snackBarClass = type === 'success' ? 'snack-success' : 'snack-error';
  //   this.snackBar.open(message, 'Close', {
  //     duration: 5000, // Duration in milliseconds
  //     panelClass: [snackBarClass], // Apply custom class based on message type
  //   });
  // }
  private showSnackBar(message: string, type: 'success' | 'error'): void {
  this.snackBar.open(message, 'Close', {
    duration: 5000,
    panelClass: type === 'success' ? ['snack-success-box'] : ['snack-error-box'],
  });
}

   // Method to toggle password visibility
 togglePasswordVisibility() {
  this.showPassword = !this.showPassword;
}
}
